export const roundNames = ['Sweet 16', 'Elite 8', 'Final 4', 'Championship'];

export const teamNamesColors = [
  {
    name: 'RevReco',
    color: '#55B4BC'
  },
  {
    name: 'The Elements',
    color: '#A98DF6'
  },
  {
    name: 'Expense It',
    color: '#EC5E59'
  },
  {
    name: 'Accrue It',
    color: '#F9C151'
  },
  {
    name: 'Debit Divas',
    color: '#5C91F5'
  },
  {
    name: 'The Normals',
    color: '#3A507B'
  },
  {
    name: 'Accruelife',
    color: '#2E7D88'
  },
  {
    name: 'LedgerSquad',
    color: '#6B3FAF'
  },
  {
    name: 'JournalUp',
    color: '#D46A28'
  },
  {
    name: 'Post&Pray',
    color: '#2A3D6C'
  },
  {
    name: 'Depreciate It',
    color: '#B8F2C4'
  },
  {
    name: 'FIFOFighters',
    color: '#C1A191'
  },
  {
    name: 'Adjust It',
    color: '#BB402A'
  },
  {
    name: 'The Source',
    color: '#FBEDD5'
  },
  {
    name: 'EarnSome',
    color: '#001B3B99'
  },
  {
    name: 'LIFOLegends',
    color: '#3B7755'
  }
];